<template>
  <div class="recommended-courses-bg">
    <div class="page-header">
      <h2>推荐课程</h2>
      <div class="filter-bar">
        <el-input
          v-model="searchQuery"
          placeholder="搜索课程"
          prefix-icon="el-icon-search"
          clearable
          class="search-input"
        />
        <el-select v-model="categoryFilter" placeholder="分类" size="small" class="filter-select">
          <el-option label="全部" value="all"></el-option>
          <el-option label="创客" value="maker"></el-option>
          <el-option label="编程" value="coding"></el-option>
          <el-option label="科学" value="science"></el-option>
        </el-select>
        <el-select v-model="sortBy" placeholder="排序" size="small" class="filter-select">
          <el-option label="最新" value="newest"></el-option>
          <el-option label="最热" value="popular"></el-option>
          <el-option label="评分最高" value="rating"></el-option>
        </el-select>
      </div>
    </div>
    <div class="course-grid">
      <div
        v-for="(course, idx) in pagedCourses"
        :key="course.id"
        class="course-card"
        :style="cardBgStyle(idx)"
        :class="{ 'is-completed': course.status === '已学习' }"
      >
        <div class="card-img-wrap">
          <img :src="course.image" :alt="course.name" class="course-img" />
          <div v-if="course.status === '已学习'" class="completed-badge">已学习</div>
        </div>
        <div class="card-content">
          <div class="course-title">{{ course.name }}</div>
          <div class="course-desc">{{ course.description }}</div>
          <div class="course-tags">
            <el-tag
              v-for="tag in course.tags"
              :key="tag"
              size="mini"
              :type="tagColor(tag)"
              class="course-tag"
            >{{ tag }}</el-tag>
          </div>
          <div class="course-meta">
            <span class="students"><i class="el-icon-user"></i> {{ course.studentCount }}人学习</span>
            <span class="rating"><i class="el-icon-star-on"></i> {{ course.rating }}</span>
          </div>
          <el-button
            :type="course.status === '未开始' ? 'primary' : 'success'"
            size="mini"
            class="start-btn"
            :disabled="course.status === '已学习'"
            @click="startLearning(course)"
          >
            {{ course.status === '未开始' ? '开始学习' : '已学习' }}
          </el-button>
        </div>
      </div>
      <div v-if="pagedCourses.length === 0" class="empty-tip">暂无推荐课程</div>
    </div>
    <div class="pagination-bar">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="filteredCourses.length"
        @current-change="handlePageChange"
        :current-page="currentPage"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AllRecommendedCourses',
  data() {
    return {
      searchQuery: '',
      categoryFilter: 'all',
      sortBy: 'newest',
      currentPage: 1,
      pageSize: 8,
      courses: [
        {
          id: 1,
          name: '小小创客掌控板',
          image: '/image/zkb.png',
          description: '学习创客掌控板、智能硬件的基础知识',
          tags: ['创客', '硬件'],
          studentCount: 320,
          rating: 4.8,
          status: '未开始'
        },
        {
          id: 2,
          name: '科学创客教育实战',
          image: '/image/kx.png',
          description: '深入学习创客教育的实战作品技巧',
          tags: ['科学', '创客'],
          studentCount: 280,
          rating: 4.7,
          status: '未开始'
        },
        {
          id: 3,
          name: '孩子编程启蒙书',
          image: '/image/qm.png',
          description: '学习实际项目中的编程应用技巧',
          tags: ['编程', '启蒙'],
          studentCount: 410,
          rating: 4.9,
          status: '已学习'
        },
        // ...可添加更多课程
      ]
    }
  },
  computed: {
    filteredCourses() {
      let result = this.courses;
      if (this.searchQuery) {
        const q = this.searchQuery.toLowerCase();
        result = result.filter(
          c => c.name.toLowerCase().includes(q) || c.description.toLowerCase().includes(q)
        );
      }
      if (this.categoryFilter !== 'all') {
        result = result.filter(c => c.tags.includes(this.categoryFilter));
      }
      if (this.sortBy === 'popular') {
        result = result.slice().sort((a, b) => b.studentCount - a.studentCount);
      } else if (this.sortBy === 'rating') {
        result = result.slice().sort((a, b) => b.rating - a.rating);
      } else {
        result = result.slice().sort((a, b) => b.id - a.id);
      }
      return result;
    },
    pagedCourses() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredCourses.slice(start, start + this.pageSize);
    }
  },
  methods: {
    startLearning(course) {
      if (course.status === '未开始') {
        course.status = '已学习';
        this.$message.success(`已加入课程：${course.name}`);
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
    },
    cardBgStyle(idx) {
      // 渐变色/柔和色块轮播
      const colorArr = [
        "linear-gradient(135deg, #e0ecff 0%, #f3f8ff 100%)",
        "linear-gradient(135deg, #fff6e0 0%, #fffbe8 100%)",
        "linear-gradient(135deg, #e6f7f1 0%, #f7fcfa 100%)",
        "linear-gradient(135deg, #f7e6fa 0%, #fdf7ff 100%)"
      ];
      return {
        background: colorArr[idx % colorArr.length]
      };
    },
    tagColor(tag) {
      // 教育相关色彩映射
      if (tag === '创客') return 'success';
      if (tag === '科学') return 'warning';
      if (tag === '编程') return 'primary';
      if (tag === '硬件') return 'info';
      if (tag === '启蒙') return 'danger';
      return 'info';
    }
  }
}
</script>

<style scoped>
.recommended-courses-bg {
  min-height: 100vh;
  background: linear-gradient(120deg, #eaf6fe 0%, #fffbe8 100%);
  padding: 36px 0 0 0;
}
.page-header {
  background: linear-gradient(90deg, #7fd0ff 0%, #a8e063 100%);
  border-radius: 0 0 28px 28px;
  padding: 0 40px 24px 40px;
  margin-bottom: 10px;
}
.page-header h2 {
  color: #2367b7;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 2px;
}
.filter-bar {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}
.search-input {
  width: 180px;
}
.filter-select {
  width: 110px;
}
.course-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  gap: 26px;
  padding: 0 40px;
  margin-top: 10px;
}
.course-card {
  /* 移除原background，渐变由js动态设置 */
  box-shadow: 0 4px 18px 0 rgba(46,162,250,0.13);
  border-radius: 18px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.18s, box-shadow 0.18s;
}
.course-card:hover {
  transform: translateY(-5px) scale(1.025);
  box-shadow: 0 6px 24px 0 rgba(46,162,250,0.18);
}
.card-img-wrap {
  position: relative;
  width: 100%;
  height: 160px;
  background: #f7fafd;
  display: flex;
  align-items: center;
  justify-content: center;
}
.course-img {
  width: 90%;
  height: 90%;
  object-fit: contain;
  border-radius: 8px;
}
.completed-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: linear-gradient(90deg, #67c23a 0%, #b7e6a5 100%);
  color: #fff;
  font-size: 13px;
  padding: 2px 10px;
  border-radius: 12px;
  font-weight: bold;
}
.card-content {
  padding: 18px 14px 16px 14px;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.course-title {
  font-size: 18px;
  font-weight: 500;
  color: #222;
  margin-bottom: 6px;
}
.course-desc {
  font-size: 13px;
  color: #8a97a8;
  margin-bottom: 7px;
  min-height: 32px;
}
.course-tags {
  margin-bottom: 7px;
}
.course-tag {
  margin-right: 6px;
  margin-bottom: 2px;
}
.course-meta {
  display: flex;
  justify-content: space-between;
  color: #b0b8c6;
  font-size: 13px;
  margin-bottom: 8px;
}
.students i,
.rating i {
  margin-right: 4px;
  color: #409EFF;
}
.rating i {
  color: #F7BA2A;
}
.start-btn {
  align-self: flex-end;
  padding: 2px 18px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 400;
  background-image: linear-gradient(90deg, #2ea2fa 0%, #7fd0ff 100%);
  color: #fff;
  border: none;
}
.start-btn[disabled] {
  background: #e0e0e0;
  color: #aaa;
}
.course-tag.el-tag--success { background: #e9fbe7; color: #47b97d; }
.course-tag.el-tag--warning { background: #fff8e1; color: #e6a23c; }
.course-tag.el-tag--primary { background: #e6f0fa; color: #409EFF; }
.course-tag.el-tag--danger { background: #ffeaea; color: #f56c6c; }
.course-tag.el-tag--info { background: #f4f4f5; color: #909399; }
.empty-tip {
  color: #aaa;
  text-align: center;
  margin: 60px 0;
  font-size: 16px;
  grid-column: 1/-1;
}
.pagination-bar {
  display: flex;
  justify-content: flex-end;
  padding: 30px 40px 0 0;
}
@media (max-width: 900px) {
  .course-grid {
    grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
    padding: 0 10px;
  }
  .page-header, .pagination-bar {
    padding: 0 10px 18px 10px;
  }
}
@media (max-width: 600px) {
  .course-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }
  .card-img-wrap {
    height: 120px;
  }
  .page-header h2 {
    font-size: 18px;
  }
}
</style>